module.exports = __webpack_public_path__ + "static/media/hilda.8e0f8fee.jpg";